const map = {
	"./buffalo/buffalo_img0.jpg": 1411,
	"./buffalo/buffalo_img1.jpg": 2998,
	"./buffalo/buffalo_img10.jpg": 3404,
	"./buffalo/buffalo_img11.jpg": 1449,
	"./buffalo/buffalo_img2.jpg": 8785,
	"./buffalo/buffalo_img3.jpg": 5188,
	"./buffalo/buffalo_img4.jpg": 1567,
	"./buffalo/buffalo_img5.jpg": 5186,
	"./buffalo/buffalo_img6.jpg": 9341,
	"./buffalo/buffalo_img7.jpg": 1248,
	"./buffalo/buffalo_img8.jpg": 2907,
	"./buffalo/buffalo_img9.jpg": 6398,
	"./buffalo/img1.JPG": 2083,
	"./buffalo/img10.JPG": 5643,
	"./buffalo/img11.JPG": 5326,
	"./buffalo/img12.JPG": 3737,
	"./buffalo/img2.JPG": 452,
	"./buffalo/img3.JPG": 3073,
	"./buffalo/img4.JPG": 8018,
	"./buffalo/img5.JPG": 4511,
	"./buffalo/img6.JPG": 5328,
	"./buffalo/img7.JPG": 4877,
	"./buffalo/img8.JPG": 3214,
	"./buffalo/img9.JPG": 2347,
	"./grad/grad_img0.jpg": 7049,
	"./grad/grad_img1.jpg": 3324,
	"./grad/grad_img2.jpg": 1019,
	"./grad/grad_img3.jpg": 4558,
	"./grad/grad_img4.jpg": 5445,
	"./grad/grad_img5.jpg": 4536,
	"./grad/grad_img6.jpg": 7111,
	"./grad/grad_img7.jpg": 4458,
	"./grad/grad_img8.jpg": 3985,
	"./iceland/iceland_img0.jpg": 8823,
	"./iceland/iceland_img1.jpg": 538,
	"./iceland/iceland_img10.jpg": 1240,
	"./iceland/iceland_img11.jpg": 9109,
	"./iceland/iceland_img12.jpg": 2858,
	"./iceland/iceland_img13.jpg": 8695,
	"./iceland/iceland_img14.jpg": 2700,
	"./iceland/iceland_img15.jpg": 3753,
	"./iceland/iceland_img16.jpg": 6638,
	"./iceland/iceland_img17.jpg": 4683,
	"./iceland/iceland_img2.jpg": 4117,
	"./iceland/iceland_img3.jpg": 152,
	"./iceland/iceland_img4.jpg": 5035,
	"./iceland/iceland_img5.jpg": 4878,
	"./iceland/iceland_img6.jpg": 6377,
	"./iceland/iceland_img7.jpg": 8588,
	"./iceland/iceland_img8.jpg": 47,
	"./iceland/iceland_img9.jpg": 3666,
	"./iceland/img1.JPG": 1112,
	"./iceland/img10.JPG": 450,
	"./iceland/img11.JPG": 8175,
	"./iceland/img12.JPG": 9216,
	"./iceland/img13.JPG": 3421,
	"./iceland/img14.JPG": 9126,
	"./iceland/img15.JPG": 7763,
	"./iceland/img16.JPG": 3188,
	"./iceland/img17.JPG": 9857,
	"./iceland/img18.JPG": 9434,
	"./iceland/img2.JPG": 5543,
	"./iceland/img3.JPG": 8778,
	"./iceland/img4.JPG": 7817,
	"./iceland/img5.JPG": 9804,
	"./iceland/img6.JPG": 9723,
	"./iceland/img7.JPG": 3054,
	"./iceland/img8.JPG": 8061,
	"./iceland/img9.JPG": 9744,
	"./nyc/nyc_img0.jpg": 7487,
	"./nyc/nyc_img1.jpg": 1106,
	"./nyc/nyc_img10.jpg": 4096,
	"./nyc/nyc_img11.jpg": 9677,
	"./nyc/nyc_img2.jpg": 8909,
	"./nyc/nyc_img3.jpg": 7168,
	"./nyc/nyc_img4.jpg": 7331,
	"./nyc/nyc_img5.jpg": 2566,
	"./nyc/nyc_img6.jpg": 4705,
	"./nyc/nyc_img7.jpg": 4756,
	"./nyc/nyc_img8.jpg": 6263,
	"./nyc/nyc_img9.jpg": 7978,
	"./puertoRico1/puertoRico1_img0.jpg": 903,
	"./puertoRico1/puertoRico1_img1.jpg": 5066,
	"./puertoRico1/puertoRico1_img10.jpg": 3144,
	"./puertoRico1/puertoRico1_img11.jpg": 5509,
	"./puertoRico1/puertoRico1_img12.jpg": 2906,
	"./puertoRico1/puertoRico1_img2.jpg": 4965,
	"./puertoRico1/puertoRico1_img3.jpg": 7096,
	"./puertoRico1/puertoRico1_img4.jpg": 6891,
	"./puertoRico1/puertoRico1_img5.jpg": 8846,
	"./puertoRico1/puertoRico1_img6.jpg": 9609,
	"./puertoRico1/puertoRico1_img7.jpg": 4908,
	"./puertoRico1/puertoRico1_img8.jpg": 3279,
	"./puertoRico1/puertoRico1_img9.jpg": 1570,
	"./puertoRico2/puertoRico2_img0.jpg": 9911,
	"./puertoRico2/puertoRico2_img1.jpg": 2394,
	"./puertoRico2/puertoRico2_img2.jpg": 6597,
	"./puertoRico2/puertoRico2_img3.jpg": 2632,
	"./puertoRico2/puertoRico2_img4.jpg": 4219,
	"./puertoRico2/puertoRico2_img5.jpg": 9262
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1370;